import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

// False during SSR and hydration, true once rendering on the client
export function useHasMounted() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
